import { render } from "./UserMultiSelectDropdown.vue?vue&type=template&id=2b0a4e2f&scoped=true"
import script from "./UserMultiSelectDropdown.vue?vue&type=script&lang=js"
export * from "./UserMultiSelectDropdown.vue?vue&type=script&lang=js"

import "./UserMultiSelectDropdown.vue?vue&type=style&index=0&id=2b0a4e2f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0a4e2f"]])

export default __exports__